import { render, staticRenderFns } from "./nbsp.vue?vue&type=template&id=65cbe3f6&"
import script from "./nbsp.vue?vue&type=script&lang=js&"
export * from "./nbsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports